// This is used to separate the IDs from root to the target object
export const IDSeparator = '-';
